import { render, staticRenderFns } from "./JSelectRole.vue?vue&type=template&id=23e7dfa0&scoped=true"
import script from "./JSelectRole.vue?vue&type=script&lang=js"
export * from "./JSelectRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7dfa0",
  null
  
)

export default component.exports